// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.ListPayment_list-payment__KASPp {
  width: 100%;
  font-family: "Sora", sans-serif;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.ListPayment_wallet-card__PyKlE {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #F7F5F1;
  border: 1px solid rgba(19, 35, 29, 0.08);
  border-radius: 20px;
  padding: 24px 32px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
}
.ListPayment_wallet-card__body__EbzgQ {
  display: flex;
  align-items: center;
  gap: 20px;
}
.ListPayment_wallet-card__icon__rklJ5 {
  width: 52px;
  height: 52px;
  background: rgba(130, 177, 148, 0.1);
  color: #82B194;
  border-radius: 14px;
  display: grid;
  place-items: center;
}
.ListPayment_wallet-card__text__So6O2 h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  color: #13231D;
}
.ListPayment_wallet-card__text__So6O2 p {
  margin: 4px 0 0;
  font-size: 14px;
  color: rgba(19, 35, 29, 0.68);
  font-weight: 500;
}
@media (max-width: 768px) {
  .ListPayment_wallet-card__PyKlE {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }
  .ListPayment_wallet-card__body__EbzgQ {
    flex-direction: column;
  }
}

.ListPayment_filters__SNdRD {
  background: #F7F5F1;
  border: 1px solid rgba(19, 35, 29, 0.08);
  border-radius: 24px;
  padding: 28px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
}
.ListPayment_filters__item__CVfdN {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ListPayment_filters__header__h-6rx {
  margin-bottom: 24px;
}
.ListPayment_filters__eyebrow__2X0jd {
  display: block;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #82B194;
  margin-bottom: 8px;
}
.ListPayment_filters__title__mv7Cj {
  margin: 0;
  font-size: 24px;
  font-weight: 800;
  color: #13231D;
}
.ListPayment_filters__grid__R5dmb {
  display: grid;
  grid-template-columns: repeat(3, 1fr) auto;
  gap: 16px;
  align-items: flex-end;
}
@media (max-width: 1300px) {
  .ListPayment_filters__grid__R5dmb {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 640px) {
  .ListPayment_filters__grid__R5dmb {
    grid-template-columns: 1fr;
  }
}
.ListPayment_filters__actions__koPDL {
  display: flex;
  gap: 12px;
  margin-bottom: 6px;
}
@media (max-width: 640px) {
  .ListPayment_filters__actions__koPDL {
    flex-direction: column;
  }
}

.ListPayment_amount-cell__Ci5cN {
  font-weight: 800;
  color: #13231D;
  font-size: 15px;
}

.ListPayment_status-tag__Y8L8N {
  display: inline-flex;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border: 1px solid transparent;
}
.ListPayment_status-tag--approved__V9Dlw, .ListPayment_status-tag--captured__Vqhgi {
  background: #E9F4EF;
  color: #4E997C;
  border-color: #d1e7dd;
}
.ListPayment_status-tag--processing__NXylF, .ListPayment_status-tag--initiated__m84so, .ListPayment_status-tag--pending_provider__Fpkts {
  background: #FEF9E7;
  color: #D6A640;
  border-color: #fcf3cf;
}
.ListPayment_status-tag--rejected__sEmHi, .ListPayment_status-tag--failed__NaVoO, .ListPayment_status-tag--canceled__TklQR {
  background: #FEF2F2;
  color: #C95C5C;
  border-color: #fadbd8;
}
.ListPayment_status-tag--refunded__iEegj {
  background: #E7EEF7;
  color: #3A5F8A;
  border-color: #d4e0ef;
}

.ListPayment_reservation-info__uc5PO {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  width: 100%;
}
.ListPayment_reservation-info__text__QEyPt p {
  margin: 0;
  font-size: 14px;
  color: #13231D;
}
.ListPayment_reservation-info__text__QEyPt span {
  font-size: 13px;
  color: rgba(19, 35, 29, 0.68);
  font-weight: 500;
}
.ListPayment_reservation-info__link__ZLbPK {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 800;
  color: #82B194;
  text-decoration: none;
  padding: 6px 12px;
  background: #fff;
  border: 1px solid rgba(130, 177, 148, 0.2);
  border-radius: 10px;
  white-space: nowrap;
  transition: all 0.2s;
}
.ListPayment_reservation-info__link__ZLbPK:hover {
  background: rgba(130, 177, 148, 0.05);
  transform: translateY(-1px);
}

@media (max-width: 1024px) {
  .ListPayment_filters__SNdRD {
    padding: 24px;
  }
  .ListPayment_filters__grid__R5dmb {
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }
}
@media (max-width: 768px) {
  .ListPayment_list-payment__KASPp {
    gap: 16px;
  }
  .ListPayment_wallet-card__PyKlE {
    padding: 24px;
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }
  .ListPayment_wallet-card__body__EbzgQ {
    flex-direction: column;
    gap: 12px;
  }
  .ListPayment_wallet-card__icon__rklJ5 {
    width: 44px;
    height: 44px;
  }
  .ListPayment_wallet-card__text__So6O2 h4 {
    font-size: 16px;
  }
  .ListPayment_wallet-card__text__So6O2 p {
    font-size: 13px;
  }
  .ListPayment_filters__SNdRD {
    padding: 20px;
    border-radius: 20px;
  }
  .ListPayment_filters__header__h-6rx {
    margin-bottom: 20px;
  }
  .ListPayment_filters__title__mv7Cj {
    font-size: 20px;
  }
  .ListPayment_filters__grid__R5dmb {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .ListPayment_filters__actions__koPDL {
    flex-direction: column;
    width: 100%;
    margin-bottom: 0;
  }
  .ListPayment_filters__actions__koPDL button {
    width: 100%;
  }
  .ListPayment_reservation-info__uc5PO {
    flex-direction: column;
    align-items: flex-end;
    text-align: right;
    gap: 8px;
    max-width: 65%;
  }
  .ListPayment_reservation-info__text__QEyPt p {
    font-size: 13px;
  }
  .ListPayment_reservation-info__text__QEyPt span {
    font-size: 12px;
  }
  .ListPayment_reservation-info__link__ZLbPK {
    padding: 4px 8px;
    font-size: 11px;
  }
  .ListPayment_amount-cell__Ci5cN {
    font-size: 14px;
  }
  .ListPayment_status-tag__Y8L8N {
    padding: 2px 10px;
    font-size: 10px;
  }
}
@media (max-width: 480px) {
  .ListPayment_filters__SNdRD {
    padding: 16px;
  }
  .ListPayment_filters__title__mv7Cj {
    font-size: 18px;
  }
  .ListPayment_reservation-info__uc5PO {
    max-width: 100%;
  }
  .ListPayment_amount-cell__Ci5cN {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/ListPayment/ListPayment.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AALA;EACE,WAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAQF;;AALA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBDJqB;ECKrB,wCAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CDuCY;AC/Bd;AANE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAQJ;AALE;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,cD5BmB;EC6BnB,mBAAA;EACA,aAAA;EACA,mBAAA;AAOJ;AAHI;EAAK,SAAA;EAAW,eAAA;EAAiB,gBAAA;EAAkB,cDtBhC;AC+BvB;AARI;EAAI,eAAA;EAAiB,eAAA;EAAiB,6BDrBnB;ECqBqC,gBAAA;AAc5D;AAXE;EA/BF;IAgCI,sBAAA;IACA,kBAAA;IACA,SAAA;EAcF;EAbE;IAAU,sBAAA;EAgBZ;AACF;;AAbA;EACE,mBDxCqB;ECyCrB,wCAAA;EACA,mBArDa;EAsDb,aAAA;EACA,2CDGY;ACad;AAdE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAgBJ;AAbE;EAAY,mBAAA;AAgBd;AAdE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cDpEmB;ECqEnB,kBAAA;AAgBJ;AAbE;EAAW,SAAA;EAAW,eAAA;EAAiB,gBAAA;EAAkB,cD3DpC;AC8EvB;AAjBE;EACE,aAAA;EACA,0CAAA;EACA,SAAA;EACA,qBAAA;AAmBJ;AAjBI;EANF;IAM+B,8BAAA;EAqB/B;AACF;AArBI;EAPF;IAO8B,0BAAA;EAyB9B;AACF;AAvBE;EACE,aAAA;EACA,SAAA;EACA,kBAAA;AAyBJ;AAxBI;EAJF;IAI8B,sBAAA;EA4B9B;AACF;;AAzBA;EACE,gBAAA;EACA,cDjFqB;ECkFrB,eAAA;AA4BF;;AAzBA;EACE,oBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,6BAAA;AA4BF;AA1BE;EAA2B,mBAAA;EAAqB,cAAA;EAAgB,qBAAA;AA+BlE;AA9BE;EAAmD,mBAAA;EAAqB,cAAA;EAAgB,qBAAA;AAmC1F;AAlCE;EAAsC,mBAAA;EAAqB,cAAA;EAAgB,qBAAA;AAuC7E;AAtCE;EAAc,mBAAA;EAAqB,cAAA;EAAgB,qBAAA;AA2CrD;;AAxCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AA2CF;AAxCI;EAAI,SAAA;EAAW,eAAA;EAAiB,cD7Gb;AC0JvB;AA5CI;EAAO,eAAA;EAAiB,6BD5GL;EC4GuB,gBAAA;AAiD9C;AA9CE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cDpImB;ECqInB,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,0CAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;AAgDJ;AA9CI;EAAU,qCAAA;EAAqC,2BAAA;AAkDnD;;AA5CA;EACE;IACE,aAAA;EA+CF;EA7CE;IACE,8BAAA;IACA,SAAA;EA+CJ;AACF;AA3CA;EACE;IACE,SAAA;EA6CF;EA1CA;IACE,aAAA;IACA,sBAAA;IACA,kBAAA;IACA,SAAA;EA4CF;EA1CE;IACE,sBAAA;IACA,SAAA;EA4CJ;EAzCE;IACE,WAAA;IACA,YAAA;EA2CJ;EAxCE;IACE,eAAA;EA0CJ;EAvCE;IACE,eAAA;EAyCJ;EArCA;IACE,aAAA;IACA,mBAAA;EAuCF;EArCE;IACE,mBAAA;EAuCJ;EApCE;IACE,eAAA;EAsCJ;EAnCE;IACE,0BAAA;IACA,SAAA;EAqCJ;EAlCE;IACE,sBAAA;IACA,WAAA;IACA,gBAAA;EAoCJ;EAlCI;IACE,WAAA;EAoCN;EA/BA;IACE,sBAAA;IACA,qBAAA;IACA,iBAAA;IACA,QAAA;IACA,cAAA;EAiCF;EA9BI;IAAI,eAAA;EAiCR;EAhCI;IAAO,eAAA;EAmCX;EAhCE;IACE,gBAAA;IACA,eAAA;EAkCJ;EA9BA;IACE,eAAA;EAgCF;EA7BA;IACE,iBAAA;IACA,eAAA;EA+BF;AACF;AA5BA;EACE;IACE,aAAA;EA8BF;EA5BE;IACE,eAAA;EA8BJ;EA1BA;IACE,eAAA;EA4BF;EAzBA;IACE,eAAA;EA2BF;AACF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../assets/styles/variables.scss';\n\n$bw-surface: $color-surface;\n$bw-surface-soft: $color-surface-soft;\n$bw-border: $border-soft;\n$bw-primary: $color-primary;\n$bw-text: $text-main;\n$bw-muted: $text-secondary;\n$bw-radius-xl: 24px;\n$bw-shadow: $shadow-card;\n\n.list-payment {\n  width: 100%;\n  font-family: \"Sora\", sans-serif;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.wallet-card {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: $bw-surface;\n  border: 1px solid $bw-border;\n  border-radius: 20px;\n  padding: 24px 32px;\n  box-shadow: $bw-shadow;\n\n  &__body {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n  }\n\n  &__icon {\n    width: 52px;\n    height: 52px;\n    background: rgba($bw-primary, 0.1);\n    color: $bw-primary;\n    border-radius: 14px;\n    display: grid;\n    place-items: center;\n  }\n\n  &__text {\n    h4 { margin: 0; font-size: 18px; font-weight: 800; color: $bw-text; }\n    p { margin: 4px 0 0; font-size: 14px; color: $bw-muted; font-weight: 500; }\n  }\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    text-align: center;\n    gap: 20px;\n    &__body { flex-direction: column; }\n  }\n}\n\n.filters {\n  background: $bw-surface;\n  border: 1px solid $bw-border;\n  border-radius: $bw-radius-xl;\n  padding: 28px;\n  box-shadow: $bw-shadow;\n\n  &__item {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &__header { margin-bottom: 24px; }\n  \n  &__eyebrow {\n    display: block;\n    font-size: 11px;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.14em;\n    color: $bw-primary;\n    margin-bottom: 8px;\n  }\n\n  &__title { margin: 0; font-size: 24px; font-weight: 800; color: $bw-text; }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr) auto;\n    gap: 16px;\n    align-items: flex-end;\n\n    @media (max-width: 1300px) { grid-template-columns: 1fr 1fr; }\n    @media (max-width: 640px) { grid-template-columns: 1fr; }\n  }\n\n  &__actions {\n    display: flex;\n    gap: 12px;\n    margin-bottom: 6px;\n    @media (max-width: 640px) { flex-direction: column; }\n  }\n}\n\n.amount-cell {\n  font-weight: 800;\n  color: $bw-text;\n  font-size: 15px;\n}\n\n.status-tag {\n  display: inline-flex;\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  border: 1px solid transparent;\n\n  &--approved, &--captured { background: #E9F4EF; color: #4E997C; border-color: #d1e7dd; }\n  &--processing, &--initiated, &--pending_provider { background: #FEF9E7; color: #D6A640; border-color: #fcf3cf; }\n  &--rejected, &--failed, &--canceled { background: #FEF2F2; color: #C95C5C; border-color: #fadbd8; }\n  &--refunded { background: #E7EEF7; color: #3A5F8A; border-color: #d4e0ef; }\n}\n\n.reservation-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n\n  &__text {\n    p { margin: 0; font-size: 14px; color: $bw-text; }\n    span { font-size: 13px; color: $bw-muted; font-weight: 500; }\n  }\n\n  &__link {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    font-weight: 800;\n    color: $bw-primary;\n    text-decoration: none;\n    padding: 6px 12px;\n    background: #fff;\n    border: 1px solid rgba($bw-primary, 0.2);\n    border-radius: 10px;\n    white-space: nowrap;\n    transition: all 0.2s;\n\n    &:hover { background: rgba($bw-primary, 0.05); transform: translateY(-1px); }\n  }\n}\n\n\n\n@media (max-width: 1024px) {\n  .filters {\n    padding: 24px;\n    \n    &__grid {\n      grid-template-columns: 1fr 1fr;\n      gap: 20px;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .list-payment {\n    gap: 16px;\n  }\n\n  .wallet-card {\n    padding: 24px;\n    flex-direction: column;\n    text-align: center;\n    gap: 16px;\n\n    &__body {\n      flex-direction: column;\n      gap: 12px;\n    }\n\n    &__icon {\n      width: 44px;\n      height: 44px;\n    }\n\n    &__text h4 {\n      font-size: 16px;\n    }\n\n    &__text p {\n      font-size: 13px;\n    }\n  }\n\n  .filters {\n    padding: 20px;\n    border-radius: 20px;\n\n    &__header {\n      margin-bottom: 20px;\n    }\n\n    &__title {\n      font-size: 20px;\n    }\n\n    &__grid {\n      grid-template-columns: 1fr;\n      gap: 16px;\n    }\n\n    &__actions {\n      flex-direction: column;\n      width: 100%;\n      margin-bottom: 0;\n      \n      button {\n        width: 100%;\n      }\n    }\n  }\n\n  .reservation-info {\n    flex-direction: column;\n    align-items: flex-end;\n    text-align: right;\n    gap: 8px;\n    max-width: 65%;\n\n    &__text {\n      p { font-size: 13px; }\n      span { font-size: 12px; }\n    }\n\n    &__link {\n      padding: 4px 8px;\n      font-size: 11px;\n    }\n  }\n\n  .amount-cell {\n    font-size: 14px;\n  }\n\n  .status-tag {\n    padding: 2px 10px;\n    font-size: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .filters {\n    padding: 16px;\n    \n    &__title {\n      font-size: 18px;\n    }\n  }\n\n  .reservation-info {\n    max-width: 100%;\n  }\n\n  .amount-cell {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list-payment": `ListPayment_list-payment__KASPp`,
	"wallet-card": `ListPayment_wallet-card__PyKlE`,
	"wallet-card__body": `ListPayment_wallet-card__body__EbzgQ`,
	"wallet-card__icon": `ListPayment_wallet-card__icon__rklJ5`,
	"wallet-card__text": `ListPayment_wallet-card__text__So6O2`,
	"filters": `ListPayment_filters__SNdRD`,
	"filters__item": `ListPayment_filters__item__CVfdN`,
	"filters__header": `ListPayment_filters__header__h-6rx`,
	"filters__eyebrow": `ListPayment_filters__eyebrow__2X0jd`,
	"filters__title": `ListPayment_filters__title__mv7Cj`,
	"filters__grid": `ListPayment_filters__grid__R5dmb`,
	"filters__actions": `ListPayment_filters__actions__koPDL`,
	"amount-cell": `ListPayment_amount-cell__Ci5cN`,
	"status-tag": `ListPayment_status-tag__Y8L8N`,
	"status-tag--approved": `ListPayment_status-tag--approved__V9Dlw`,
	"status-tag--captured": `ListPayment_status-tag--captured__Vqhgi`,
	"status-tag--processing": `ListPayment_status-tag--processing__NXylF`,
	"status-tag--initiated": `ListPayment_status-tag--initiated__m84so`,
	"status-tag--pending_provider": `ListPayment_status-tag--pending_provider__Fpkts`,
	"status-tag--rejected": `ListPayment_status-tag--rejected__sEmHi`,
	"status-tag--failed": `ListPayment_status-tag--failed__NaVoO`,
	"status-tag--canceled": `ListPayment_status-tag--canceled__TklQR`,
	"status-tag--refunded": `ListPayment_status-tag--refunded__iEegj`,
	"reservation-info": `ListPayment_reservation-info__uc5PO`,
	"reservation-info__text": `ListPayment_reservation-info__text__QEyPt`,
	"reservation-info__link": `ListPayment_reservation-info__link__ZLbPK`
};
export default ___CSS_LOADER_EXPORT___;
